import {useLocation, useParams} from "react-router";
import Navbar from "../components/Navbar/Navbar";
import {useTranslation} from "react-i18next";
import {mustache} from "../Helpers/functions";
import {Alert, Col, Container, ListGroup, Row} from "react-bootstrap";
import style from "../components/PaymentItems/Payment.module.css";
import { useCallback, useEffect, useState } from "react";
import getPaymentRequest from "../Api/Requests/get-payment.request";
import getPaymentStatusRequest from "../Api/Requests/get-payment-status.request";
import useHttp from "../Hooks/use-http/use-http";
import { DynamicObject } from "../models/General";
import { configGetPaymentStatusApi } from "../Api/api.config";
import { AxiosError, AxiosResponse } from "axios";
import getCliqPaymentStatusRequest from "../Api/Requests/get-cliq-payment-status.request";
import i18n from "../i18n";

const CliqSteps = () => {
    const location = useLocation();
    const data = location.state
    const {t} = useTranslation();
    const [hasGeneralError, setHasGeneralError] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [apiHits, setApiHits] = useState(0);
    const [responseData, setResponseData] = useState<DynamicObject | undefined>()

    const checkOrderStatus = () => {
        getCliqPaymentStatusRequest({paymentSecret : data?.paymentSecret}).then((response) => {
            // redirect the user
            if(response.data.redirectTo && response.data.redirectTo != ''){
              window.location.href = response.data.redirectTo;
            }
            setApiHits(prevHits => prevHits + 1);
        }).catch((error) => {
            setApiHits(prevHits => prevHits + 1);
        })
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
          if (apiHits < 30) {
            checkOrderStatus();
          } else {
            clearInterval(intervalId);
          }
        }, 20000);
        return () => {
          clearInterval(intervalId);
        };
      }, [apiHits]);
      
    return (<div dir={i18n.language=='en'?'ltr':'rtl'} > <div className={`${style.blocked_background}`} id={'background-popup'}></div>
        <Container className={`sm-pad-zero `}>
            <Row className={`justify-content-center `}>
                <Col className={`${style.parent_container}`} lg={6} md={8} sm={10}>
                    <Navbar referral_url={''} loading={false} title={t('cliq.payUsingCliq')}subTitle={mustache(t('page.payment.subtitle'), {cartId: data?.cartId})} />
                    <div style={{marginTop:"10px" ,padding : "20px"}}>
                        <Alert key={'danger'} variant={'danger'} show={hasGeneralError}>
                            {t('cliq.error')}
                        </Alert>
                        <ol type="1" style={{fontSize:"14px"}}>
                            <li>{t('cliq.step1')}</li>
                            <li>{t('cliq.step2')}</li>
                            <li>{t('cliq.step3')}</li>
                            <li>{t('cliq.step4')}</li>
                            <li>{t('cliq.step5')}</li>
                        </ol>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>)
}
export default CliqSteps